import React from "react";
import TimeAgo from "react-timeago";
import SiteProfile from "../Site/partials/siteProfile";
import StaffProfileCare from "../../Staff/partials/StaffProfileCard";

const SubPartialDetailView = ({ item }) => {
	return (
		<div className="height-9">
			<ul className="list-group list-group-unbordered">
				<li className="list-group-item">
					<span className="text-muted">Next Subscription Date</span>
					<h4>
						{Intl.DateTimeFormat("en-GB", {
							weekday: "short",
							year: "numeric",
							month: "long",
							day: "numeric"
						}).format(new Date(item.nextSubDate))}
					</h4>
					<p className="text-muted">
						Updated <TimeAgo date={item.lastUpdate} />
					</p>
				</li>
				<li className="list-group-item">
					<span className="text-muted">Amount Paid</span>
					<h4>
						{item.currency} {Intl.NumberFormat("en-GB").format(item.amount)}
					</h4>
				</li>
				<li className="list-group-item">
					<span className="text-muted">Site Information</span>
					<SiteProfile site={item.site} />
				</li>
				<li className="list-group-item">
					<span className="text-muted">Total Days to next renewal</span>
					<h4>
						{item.remainingDays} {item.remainingDays < 2 ? "Day" : "Days"}
					</h4>
				</li>
				<li className="list-group-item">
					<span className="text-muted">Created By</span>
					<StaffProfileCare item={item.creator} />
				</li>
			</ul>
		</div>
	);
};

export default SubPartialDetailView;
